import { bigNumberify, NormalizedNumber, Percentage } from '@sparkdotfi/common-universal'
import BigNumber from 'bignumber.js'

import { SavingsConverter } from './types'
import { fromRay, pow } from '@/utils/math'

export interface PotParams {
  sr: BigNumber
  rho: BigNumber
  chi: BigNumber
}
export interface PotSavingsConverterParams {
  potParams: PotParams
  currentTimestamp: number
}

export class PotSavingsConverter implements SavingsConverter {
  apy: Percentage
  readonly potParams: PotParams
  readonly currentTimestamp: number

  constructor({ potParams, currentTimestamp }: PotSavingsConverterParams) {
    this.potParams = potParams
    this.currentTimestamp = currentTimestamp
    this.apy = Percentage(pow(fromRay(potParams.sr), 60 * 60 * 24 * 365).minus(1), { allowMoreThan1: true })
  }

  get supportsRealTimeInterestAccrual(): boolean {
    return true
  }

  private getUpdatedChi(timestamp: number): BigNumber {
    const { sr, rho, chi } = this.potParams
    return fromRay(pow(fromRay(sr), bigNumberify(timestamp).minus(rho)).times(chi))
  }

  convertToShares({ assets }: { assets: NormalizedNumber }): NormalizedNumber {
    return this.predictSharesAmount({ timestamp: this.currentTimestamp, assets })
  }

  convertToAssets({ shares }: { shares: NormalizedNumber }): NormalizedNumber {
    return this.predictAssetsAmount({ timestamp: this.currentTimestamp, shares })
  }

  predictAssetsAmount({ timestamp, shares }: { timestamp: number; shares: NormalizedNumber }): NormalizedNumber {
    const updatedChi = this.getUpdatedChi(timestamp)
    return shares.times(NormalizedNumber(updatedChi))
  }

  predictSharesAmount({ timestamp, assets }: { timestamp: number; assets: NormalizedNumber }): NormalizedNumber {
    const updatedChi = this.getUpdatedChi(timestamp)
    return assets.div(NormalizedNumber(updatedChi))
  }
}
